import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "enterDelay"],
  _excluded2 = ["onClick", "children", "className", "disableUnderline", "TooltipProps"];
import { Tooltip, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef, useState } from 'react';
import { ColorDynamic } from "../theme/Color.js";
import { VisibilityObserver } from "../utils/VisibilityObserver.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    marginBottom: -1,
    borderBottom: '1px dashed transparent',
    transition: theme.transitions.create('border'),
    '&$truncated': {
      cursor: 'pointer',
      borderBottomColor: ColorDynamic.Silver500
    }
  },
  truncated: {},
  sentinel: {
    width: 1,
    height: '100%',
    display: 'inline-block'
  }
}), {
  name: 'SD-OverflowText'
});
export var OverflowText = /*#__PURE__*/forwardRef((_ref, rootRef) => {
  var {
      onClick: _onClick,
      children,
      className,
      disableUnderline,
      TooltipProps: {
        title = children,
        enterDelay = 1000
      } = {}
    } = _ref,
    tooltipProps = _objectWithoutProperties(_ref.TooltipProps, _excluded),
    props = _objectWithoutProperties(_ref, _excluded2);
  var [isOpen, setIsOpen] = useState(false);
  var styles = useStyles();
  return /*#__PURE__*/_jsx(VisibilityObserver, {
    render: _ref2 => {
      var {
        ref,
        visibility
      } = _ref2;
      var isTooltipEnabled = !!children && visibility === 'invisible';
      return /*#__PURE__*/_jsx(Tooltip, _objectSpread(_objectSpread({}, tooltipProps), {}, {
        enterDelay: 1000,
        title: title || '',
        disableFocusListener: true,
        open: isOpen && isTooltipEnabled,
        onOpen: () => {
          setIsOpen(true);
        },
        onClose: () => {
          setIsOpen(false);
        },
        children: /*#__PURE__*/_jsxs(Typography, _objectSpread(_objectSpread({}, props), {}, {
          ref: rootRef,
          noWrap: true,
          onClick: event => {
            setIsOpen(true);
            _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
          },
          className: clsx(styles.root, {
            [styles.truncated]: !disableUnderline && visibility === 'invisible'
          }, className),
          children: [children, !!children && /*#__PURE__*/_jsx("span", {
            ref: ref,
            className: styles.sentinel
          })]
        }))
      }));
    }
  });
});
if (process.env.NODE_ENV !== "production") OverflowText.displayName = "OverflowText";